export const environment = {
  production: false,
  config: 'Portal', //Portal
  authConfig: 'Entra',
  ServerApiUrl:
    'https://idcloudedition2025service-erg9d9embuemf8b4.westeurope-01.azurewebsites.net/api/', //http://localhost:1337/api/
  msalConfig: {
    tenant: 'selectedat.onmicrosoft.com',
    clientId: '426bafb3-9244-4000-bb89-461908fe0a35',
    serviceClientId: 'db784e73-e5b0-4141-aba4-0fc8d0cf029a',
  },
  endpoints: [
    {
      name: 'OnPrem Demo',
      api: 'https://demo.identitydirector.com/',
      cloud: false,
    },
    {
      name: 'Cloud Development',
      api: 'http://localhost:1337/api/',
      cloud: true,
    },
    {
      name: 'Cloud Development Local',
      api: 'http://localhost:1337/api/',
      cloud: true,
    },
    {
      name: 'OnPrem Development',
      api: 'http://id:8080/',
      cloud: false,
    },
    {
      name: 'OnPrem Development Old',
      api: 'https://idmui.westeurope.cloudapp.azure.com:4435/',
      cloud: false,
    },
  ],
};
